const config_api = require("../../../config/config").config_api;
const utils = require("../../../utils");
const axios = require("axios");

function requestRevenue(url, filter, callback) {
  axios({
    url: url,
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: "Bearer " + utils.getAuthToken(),
    },
    params: filter,
  })
    .then((result) => {
      return callback(null, result.data);
    })
    .catch((error) => {
      if (error.response) {
        return callback(error.response);
      } else if (error.request) {
        return callback("Đường truyền bị gián đoạn");
      } else {
        return callback(error.message);
      }
    });
}

function getKTMNRevenue(filter, callback) {
  requestRevenue(config_api.thirdPartyRevenue, filter, callback);
}

function getKTMTRevenue(filter, callback) {
  requestRevenue(config_api.thirdPartyRevenueKTMT, filter, callback);
}

function getTransRevenue(filter, callback) {
  requestRevenue(config_api.thirdPartyRevenue_All, filter, callback);
}

export { getKTMNRevenue, getKTMTRevenue, getTransRevenue };
